import {useEffect} from "react";
import {useForm, Controller} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {Button, Loading} from "~/components";
import {SelectUserAll} from "~/components/Forms";

//Chức vụ copywriter (Copy writing) trong phòng MKT Kỹ thuật
const COPYWRITER_ROLES = ['marketingContent', 'marketingContentManager'];

function MarketingProjectFormAssignCopywriter({item, onHandleSubmit}) {

	const copywriterOptions = item?.copywriter?.id
		? [{label: `${item.copywriter.firstname} ${item.copywriter.lastname}`, value: item.copywriter.id}]
		: [];

	const initialValues = {
		copywriterId: item?.copywriterId || '',
	}

	const validationSchema = Yup.object().shape({
		copywriterId: Yup.number().typeError('Bạn chưa chọn nhân viên copywriter').required('Bạn chưa chọn nhân viên copywriter'),
	});

	const {control, handleSubmit, formState: {isSubmitting, errors}, reset} = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	useEffect(() => {
		reset(initialValues);
	}, [item]);

	const onSubmit = async (data) => {
		await onHandleSubmit(data, item);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<p className="heading">Nhân viên copywriter phụ trách dự án</p>
			<Controller control={control} name="copywriterId" render={({field}) => (
				<SelectUserAll placeholder="Chọn nhân viên copywriter" role={COPYWRITER_ROLES} options={copywriterOptions} errors={errors} {...field} />
			)}/>
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Phân công copywriter</Button>
			</div>
		</form>
	)
}

export default MarketingProjectFormAssignCopywriter;
